import TemplateFormatRepository from './templateFormatRepository';
import ProjectRepository from './projectRepository';
import UploadRepository from './uploadRepository';
import ProductRepository from './productRepository';
import SessionRepository from './sessionRepository';
import PlaceholderRepository from './placeholderRepository';

const repositories = {
    formats: TemplateFormatRepository,
    projects: ProjectRepository,
    upload: UploadRepository,
    product: ProductRepository,
    session: SessionRepository,
    placeholders: PlaceholderRepository
};

export const RepositoryFactory = {
    get: (name) => {   
        return repositories[name]
    }
}
